module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of Travel\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Disability Living Allowance (mobility component)",
      "store-key": "pcotDisabilityLivingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Mobility Allowance",
      "store-key": "pcotMobilityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Personal Independence Payment (mobility component)",
      "store-key": "pcotPersonalIndependencePayment",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a9f84ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/lost-years-claims/steps/cru-benefits/PastCostOfTravel.vue
// module id = 1565
// module chunks = 0